var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreastackedPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 200,
    viewBox: "0 0 282 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13906_7678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65527 138.9L0 146.899V200H282V0L277.356 6.92852H273.228L266.52 13.857L261.36 20.7856L256.2 36.0283H250.008L243.817 47.114L231.433 67.5281L214.9 91.4565L209.245 98.385H197.935L187.057 108.085L181.898 124.713L175.706 141.361L167.966 153.051L164.003 167.818L158.348 152.436L152.692 141.361L147.037 167.203L141.382 173.355L135.727 165.972L130.071 161.05L124.416 166.587L118.761 153.051L113.105 174.586L109.143 166.587H105.015L101.795 177.662L93.1469 160.435H90.4844L84.8291 146.899L73.5186 149.975L67.8633 147.514L62.208 132.747L58.5754 148.744L55.4795 160.435L45.2422 161.665L39.5869 176.432L33.9316 173.355L28.2764 165.972L22.6211 173.355L16.9658 165.357L11.3105 135.208L5.65527 138.9Z",
    fill: "url(#paint0_linear_13906_7678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 179.9H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 150.754H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120.603H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4523H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61.3065H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.1558H282",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40991 148.005L7.06518 139.946L12.7205 136.226L18.3757 166.602L24.031 174.661L29.6863 167.222L35.3416 174.661L40.9968 177.76L46.6521 162.882L56.8894 161.643L59.9853 149.864L63.6179 133.747L69.2732 148.625L74.9285 151.104L86.239 148.005L91.8943 161.643H94.5568L103.205 179L106.425 167.842H110.553L114.515 175.9L120.171 154.204L125.826 167.842L131.481 162.262L137.136 167.222L142.792 174.661L148.447 168.462L154.102 142.425L159.758 153.584L165.413 169.081L169.376 154.204L177.116 142.425L183.307 125.652L188.467 108.899L199.344 99.1258H210.655L216.31 92.1451L232.843 68.0366L245.227 47.4687L251.418 36.2996H257.61L262.77 20.9421L267.93 13.9614L274.638 6.98069H278.766L283.41 0",
    stroke: "#373D43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13906_7678",
    x1: 141.638,
    y1: 131.429,
    x2: 141.215,
    y2: 200.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13906_7678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreastackedPreview);
export default __webpack_public_path__ + "static/media/areastackedPreview.b63ead9252257620f37356d751a29934.svg";
export { ForwardRef as ReactComponent };